import {
  type MerchantPricingDto,
  type ProductCode,
  type MerchantFeeDto,
  MerchantPricingVariant,
  ProductCode as ProductCodeEnum,
} from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import type { ProductPricingCategory } from "Types/MerchantPricingCategories";

export const VARIANT_TO_CATEGORY_MAP: Partial<
  Record<MerchantPricingVariant, ProductPricingCategory>
> = {
  [MerchantPricingVariant.Variant1]: "Standard",
  [MerchantPricingVariant.Variant2]: "Prime",
  [MerchantPricingVariant.Variant3]: "Partner",
  [MerchantPricingVariant.Individual]: "Individual",
};

export const getVariantCategoryName = (
  productCode: ProductCode | undefined,
  variant: MerchantPricingVariant | null | undefined,
  t: TFunction,
): string => {
  if (productCode !== ProductCodeEnum.OrbitS || !variant) {
    return "";
  }

  const categoryKey = VARIANT_TO_CATEGORY_MAP[variant];

  if (!categoryKey) {
    return "";
  }

  return t(Resources.Components.Merchant.Pricings.CategoryNames[categoryKey]);
};

export const getMerchantOrbitSPricingCategory = (
  fees: Array<MerchantFeeDto>,
  allPricings: Array<MerchantPricingDto>,
): ProductPricingCategory | null => {
  const orbitSFee = fees.find(
    ({ productCode }) => productCode === ProductCodeEnum.OrbitS,
  );

  if (!orbitSFee?.merchantPricingID) {
    return null;
  }

  const pricing = allPricings.find(
    (pricing) =>
      pricing.merchantPricingID === orbitSFee.merchantPricingID &&
      pricing.code === ProductCodeEnum.OrbitS &&
      pricing.merchantPricingVariant,
  );

  const pricingVariant = pricing?.merchantPricingVariant;

  if (!pricingVariant) {
    return null;
  }

  const category = VARIANT_TO_CATEGORY_MAP[pricingVariant];

  return category ?? null;
};
